import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { BoxHistoryPage } from '@/components/BoxHistory/BoxHistoryPage'
import { boxHistorySearchSchema, withoutSearchDefaults } from '@/components/BoxHistory/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/box-history/')({
  validateSearch: boxHistorySearchSchema,
  component: BoxHistoryRoute,
})

function BoxHistoryRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <BoxHistoryPage
      search={search}
      onSearchChange={(next) => void navigate(inPageSearch(withoutSearchDefaults, next))}
    />
  )
}
